import { render, staticRenderFns } from "./ProductCardWithPagination.vue?vue&type=template&id=5f7806d9&scoped=true&"
import script from "./ProductCardWithPagination.vue?vue&type=script&lang=js&"
export * from "./ProductCardWithPagination.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardWithPagination.vue?vue&type=style&index=0&id=5f7806d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7806d9",
  null
  
)

export default component.exports